import React, { useState } from 'react';
import style from './style.scss';
import cn from 'classnames';
import { Card, CardFooter, CardImg, Jumbotron } from 'reactstrap';
import Header from 'components/Header';
import { faqLeftSectionData, faqRightSectionData, trainingSessions } from './training-center-data';
import ArrowUp from 'assets/images/arrow-up.png';
import ArrowDown from 'assets/images/down.png';
import StarDivider from 'assets/images/star-divider.png';

const TrainingCenter = () => {
  const [openQuestionIndex, setOpenQuestionIndex] = useState(null);

  const toggleQuestion = (questionId) => {
    setOpenQuestionIndex(openQuestionIndex === questionId ? null : questionId);
  };

  const renderFAQSection = data => (
    data.map((category, categoryIndex) => (
      <div
        className={style.faqcategory}
        key={categoryIndex}
        style={{ flex: 1, minWidth: '98%', margin: '2% 1%' }}
      >
        <h3>{category.header}</h3>
        <div className={style.faqcategoryquestion}>
          {category.questions.map((question, questionIndex) => (
            <div key={question.id} style={{ borderBottom: (questionIndex + 1) === category.questions.length ? 'none' : '1px solid #f2f1f0' }}>
              <div
                style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: 'pointer' }}
                onClick={() => toggleQuestion(question.id)}
              >
                <p className={style.question}>{question.question}</p>
                <div className={style.arrowicon}>
                  <img
                    src={openQuestionIndex === question.id ? ArrowUp : ArrowDown}
                    alt="arrow"
                  />
                </div>
              </div>
              {openQuestionIndex === question.id && (
                <div>
                  <p className={style.answer}>
                    {question.answer}
                    <br /><br />
                    <a style={{ color: '#002147', textDecoration: 'underline', fontWeight: 'bold' }} href={question.link} target="_blank" rel="noopener noreferrer">
                      Book a Training Here
                    </a>
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    ))
  );

  return (
    <div className={style.trainingcenterwraper}>
      <Header />
      <Jumbotron className={cn('text-center px-0 pb-0 pt-4', style.jumbo)}>
        <h1 className="pt-1 pb-1" style={{ color: '#002147' }}>
          Training and Knowledge Center
        </h1>
        <p className={style.font_16} style={{ padding: '30px', paddingTop: '11px', maxWidth: '1080px', margin: '0 auto' }}>
          Welcome to the Training and Knowledge Center! Our comprehensive platform is designed to provide you with
          valuable training resources and essential FAQs to enhance your knowledge and skills. Start exploring our
          curated training links to begin your learning journey today.
        </p>
      </Jumbotron>
      <div className={style.container}>
        <section className={style.trainingsession}>
          <h4>Book a Training Session</h4>
          <div className={style.trainingCardWrapper}>
            {trainingSessions.length > 0 && trainingSessions.map((trainingSession, index) => (
              <Card className={style.trainingCard} key={index}>
                <CardImg top width="100%" src={trainingSession.banner} alt="Guide Image" />
                <CardFooter className={`pt-2 pb-4 ${style.footer}`}>
                  <h5 className="mt-1 mb-0">{trainingSession.title}</h5>
                  <p className="mt-1 mb-0">{trainingSession.description}</p>
                  <p className="mt-1 mb-0"><strong>{trainingSession.sessionTiming}</strong></p>
                  <button
                    className="button green w-100 mt-1"
                    onClick={() => window.open(trainingSession.sessionLink, '_blank')}
                  >
                    <b>Book a Training</b>
                  </button>
                </CardFooter>
              </Card>
            ))}
          </div>
        </section>

        <div style={{ textAlign: 'center', paddingTop: '40px' }}>
          <img src={StarDivider} alt="divider" />
        </div>

        <div className={style.faq}>
          <h4 className={style.faqheading}>Frequently Asked Questions</h4>
          <div style={{ display: 'flex', alignItems: 'flex-start', flexWrap: 'wrap' }}>
            <div style={{ width: '50%' }}>
              {renderFAQSection(faqLeftSectionData)}
            </div>
            <div style={{ width: '50%' }}>
              {renderFAQSection(faqRightSectionData)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrainingCenter;



// WEBPACK FOOTER //
// ./src/containers/pages/TrainingCenter/index.js